import styled from 'styled-components'

export const Container = styled.div<{ $backgroundColor: string }>`
    align-items: center;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    position: relative;

    &:before {
        background: ${({ $backgroundColor }) => $backgroundColor};
        border-radius: inherit;
        content: '';
        height: 100%;
        left: 0;
        opacity: 0.9;
        position: absolute;
        top: 0;
        width: 100%;
    }
`
